import getAngleBetweenPoints from "./getAngleBtwPoints";

export default function  calculateAngles(cCoord, cStart, cEnd) {
  const startRadian = getAngleBetweenPoints(cCoord, cStart);
  const endRadian = getAngleBetweenPoints(cCoord, cEnd);
  return { startRadian, endRadian }
}